<!-- Failure Popup for submit documentation-->
<div id="managePopUp">
  <div class="modal-header">
      <span class="failureIcon"></span>
      <span class='modal-title'>{{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.failureTxt}}</span>
  </div>
  <div class="modal-body">
      <div>
          <p class="headerPart">{{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.failureHeaderTxt}}</p>
      </div>
       <div>
          <p>
            <span> {{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.subHeaderTxt}} </span>
            <span class="customerCare">{{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.subHeaderTxt1}} </span>
        </p>
      </div>
  </div>
  <div class="modal-footer pull-right popup_btnbox  bottom_aligner ">
      <div class="btnFullWidth">
            <button type='button' class='secondary_btn' id='cancelButton' (click)="onClose()">{{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.cancel}}</button>
      </div>
      <div class="btnFullWidth">
            <button type='button' class='primary_btn' id='startButton' (click)="openUploadDocumentScreen()">{{militaryVerficationDocumentUpload?.militaryVerficationDocumentUpload?.startOver}}</button>
      </div>
  </div>

</div>